import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import bankService from "../../../services/ref/bankService";
import Cookies from "js-cookie";

export const initialState = {
    loading_bank: false,
    data_bank: [],
    showMessage:false,
    message:'',
}


export const getDataBank = createAsyncThunk('bank/data',async (data, { rejectWithValue }) => {
    try {
        const response = await bankService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const bankSlice = createSlice({
    name: 'bank',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_bank = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataBank.fulfilled, (state, action) => {
                state.loading_bank = false
                state.data_bank = action.payload??[]
            })
            .addCase(getDataBank.pending, (state) => {
                state.loading_bank = true
            })
            .addCase(getDataBank.rejected, (state, action) => {
                state.loading_bank = false
                state.data_bank = action.payload
            })
    },
})

export const {
    showLoading,
} = bankSlice.actions

export default bankSlice.reducer
